
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDamperHorizontalOff as ObiDamperHorizontalOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-damper-horizontal-off.js';
 
 
 

 
 export const ObiDamperHorizontalOff = createComponent({
   react: React,
   tagName: 'obi-damper-horizontal-off',
   elementClass: ObiDamperHorizontalOffElement,
   events: {
     
   }
  });
 
 